import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PopoverModule } from 'ngx-smart-popover';
import { PageHeaderModule } from '../_shared/page-header/page-header.module';
import { LayoutComponent } from './layout.component';

@NgModule({
  declarations: [
    LayoutComponent,
    // WhatsappComponent
  ],
  imports: [
    CommonModule,
    RouterModule,

    PageHeaderModule,
    PopoverModule
  ],
  exports:[
      LayoutComponent
  ]
})
export class LayoutModule { }
